import type { BlogPost } from "./types";

/**
 * Blog post registry (NCS-197).
 *
 * Every `*.post.ts` file in this directory that default-exports a `BlogPost` is
 * picked up automatically at build time via Vite's `import.meta.glob`. To publish
 * a new post, drop in a new `my-slug.post.ts` — no registration needed here.
 *
 * Posts are sorted newest-first by `date`.
 */
const modules = import.meta.glob<{ default: BlogPost }>("./*.post.ts", {
  eager: true,
});

export const posts: BlogPost[] = Object.values(modules)
  .map((m) => m.default)
  .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

/** Fast slug → post lookup for the `/blog/:slug` route. */
const bySlug = new Map(posts.map((p) => [p.slug, p]));

export function getPost(slug: string | undefined): BlogPost | undefined {
  return slug ? bySlug.get(slug) : undefined;
}

export type { BlogPost };
